import checkout from './checkout'
import account from './account'
import payment from './payment'
import product from './product'
import subscription from './subscription'
import billing from './billing'
import support from './support'
import admin from './admin'
import order from './order'
import cart from './cart'

export default {
  checkout,
  account,
  payment,
  product,
  subscription,
  billing,
  support,
  admin,
  order,
  cart
}
